<template>
  <b-modal
    id="add-referral-link-modal"
    ref="addReferralLinkModalRef"
    hide-footer
  >
    <template v-slot:modal-header="{ close }">
      <div class="title">CUSTOM REFERRAL LINK</div>
      <b-link class="modal-close-link float-right" right @click="close()">
        <i class="pe-7s-close close-icon"></i>
      </b-link>
    </template>

    <div class="box pt-4 pb-4">
      <div class="box-part" id="bp-left">
        <div class="partition" id="partition-register">
          <div class="partition-form">
            <form
              class="pb-4"
              autocomplete="false"
              ref="updateProductUrlForm"
              @submit.prevent="submitUpdateLayerProduct"
            >
              <input
                v-model.trim="urlText"
                type="text"
                placeholder="Enter product's referral link"
                class="w-100"
              />
              <div class="reset w-100">
                <b-link
                  class="reset-link"
                  @click="resetUrl()"
                  v-if="hasCustomReferralUrl"
                  >reset</b-link
                >
              </div>
            </form>

            <button
              type="submit"
              name="button"
              class="add-product-btn w-100"
              v-on:click="submitUpdateLayerProduct"
              v-html="buttonText"
              :disabled="isDisabled"
            />
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapActions } from "vuex";
import { bus } from "@/main";

export default {
  name: "AddCustomReferralUrlModal",

  data() {
    return {
      capsuleId: null,
      layerProduct: null,
      urlText: null,
      originalUrl: null,
      hasCustomReferralUrl: null
    };
  },

  mounted() {
    bus.$on("openAddReferralLinkModal", ({ capsuleId, layerProduct }) => {
      if (this.$refs.addReferralLinkModalRef) {
        this.resetData(capsuleId, layerProduct);
        this.$refs.addReferralLinkModalRef.show();
      }
    });
  },

  methods: {
    ...mapActions(["updateCapsuleLayerProduct"]),

    resetData(capsuleId, layerProduct) {
      this.capsuleId = capsuleId;
      this.layerProduct = layerProduct;
      this.originalUrl = layerProduct.external_url;
      this.hasCustomReferralUrl = layerProduct.custom_url;
      this.urlText = this.hasCustomReferralUrl ? this.originalUrl : null;
    },

    resetUrl() {
      this.urlText = null;
      this.submitUpdateLayerProduct();
    },

    submitUpdateLayerProduct() {
      const payload = {
        capsuleId: this.capsuleId,
        layerProductId: this.layerProduct.id,
        externalUrl: this.urlText
      };

      this.updateCapsuleLayerProduct(payload);
      this.$bvModal.hide("add-referral-link-modal");
    }
  },

  computed: {
    buttonText() {
      return "Save";
    },

    isDisabled() {
      return !this.urlText || this.urlText === this.originalUrl;
    }
  }
};
</script>
<style lang="scss">
@import "~@/styles/_colour-palette.scss";

#add-referral-link-modal {
  .modal-content {
    min-height: auto !important;
    border-radius: 0px;
    border-color: transparent;
  }

  .modal-header {
    padding-bottom: 10px;

    border-radius: 0;
    background-color: $grey5;
    background-color: $primary-accent;

    .title {
      color: white;
      letter-spacing: 1px;
      font-size: 20px;
      font-weight: 300;
    }

    .modal-close-link {
      color: white;

      &:hover {
        color: $primary-blue;
      }

      .close-icon {
        font-size: 32px;
      }
    }
  }

  .modal-body {
    padding-left: 30px;
    padding-right: 30px;

    input[type="text"] {
      margin-bottom: 4px;
      padding: 4px 8px;
      border: 0;
      border-bottom: 1px solid #dddedf;

      font-size: 12px;
      line-height: 2;
    }

    .add-product-btn {
      cursor: pointer;
      margin-top: 8px;
      padding: 10px;
      border: 1px solid $grey5;
      background: white;
      color: #8b8c8d;

      font-size: 10px;
      letter-spacing: 1px;
      text-transform: uppercase;
      transition: 0.1s all;

      &:enabled {
        border-color: $primary-blue;
        color: $primary-blue;

        &:hover {
          background: $primary-blue;
          border-color: $primary-blue;
          color: white;
        }
      }

      &:disabled {
        cursor: auto;
        background: #d9d9d9;
        color: white;
      }

      .site-name {
        font-weight: 600;
      }
    }

    .reset {
      text-align: right;

      .reset-link {
        color: $primary-accent;
        font-size: 10px;
        letter-spacing: 1px;
        text-transform: uppercase;

        &:hover {
          text-decoration: none;
        }
      }
    }
  }

  .modal-footer {
    border-color: $grey5;
    background-color: $grey6;

    .wrapper {
      cursor: pointer;

      .supporting-sites {
        display: flex;
        justify-content: space-between;
        color: $grey3;

        .expand-icons {
          font-size: 28px;
        }
      }
    }

    .logos {
      opacity: 40%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/capsuleBuilder/modals/AddCustomReferralUrlModal.vue